/**
 * Catch-up scheduling for chat rooms (chat-reconnect-catchup).
 *
 * The live feed doesn't replay inserts a phone missed while it was offline or
 * backgrounded. When there may have been a gap — the feed rejoined, the network
 * came back, the page returned to the front — the room re-reads from the DB.
 * Several of those signals arrive together (a return to the front often
 * triggers a rejoin too), so requests for a room are coalesced: one run per
 * room per `delayMs` window.
 *
 * @param {(chatRoomId: string) => void} run - does the re-read
 * @param {number} [delayMs=1500]
 */
export const createCatchUpScheduler = (run, delayMs = 1500) => {
  const pending = new Map();
  return {
    request(chatRoomId) {
      if (!chatRoomId || pending.has(chatRoomId)) return;
      pending.set(
        chatRoomId,
        setTimeout(() => {
          pending.delete(chatRoomId);
          run(chatRoomId);
        }, delayMs)
      );
    },
    cancel(chatRoomId) {
      clearTimeout(pending.get(chatRoomId));
      pending.delete(chatRoomId);
    },
  };
};
